import React, { Component } from 'react'
import {
  Alert, Button, Col, Row, ButtonContainer, FormInputCheckbox
} from 'camino-react'
import _, { filter } from 'lodash'
import moment from 'moment-timezone'

import AssociatedItemsSelectors from './AssociatedItemsSelectors'

import { cloudhelpGet, cloudhelpPatch } from 'Utilities/CloudHelp'

const types = {
  attribute: {
    label: 'Attribute',
    editableType: 'Attribute',
    keySelector: 'attribute'
  }
}

const optionsToUpdate = [
  'assignee',
  'category',
  'client',
  'queue',
  'status',
  'ticket_type',
  'priority'
]

class BulkUpdateForm extends Component {
  constructor (props) {
    super(props)

    const editedItems = []

    const initialItems = _.map(types, type => Object.assign(
      {}, { editableType: type.editableType }
    ))

    const editedItemsWithInitialItems = Object.assign([], [...editedItems, ...initialItems])

    this.state = {
      showAlertRegion: false,
      errorTicketsRegion: '',
      errorRegionClient: '',
      groupedTickets: [],
      validTicketsToUpdate: [],
      serviceCategories: [],
      regionStatuses: [],
      selectedRegionToUpdate: {},
      regionToUpdate: '',
      fieldsErrors: [],
      showOnHoldOrResolved: false,
      fields: {
        editedItems: editedItemsWithInitialItems
      },
      alert: {
        showAlert: false,
        alertText: '',
        alertType: ''
      },
      multipleTicketTypesSelected: false
    }
  }

  componentDidMount () {
    this.checkIfTicketsRegionIsSame()
  }

  checkIfTicketsRegionIsSame = () => {
    const { ticketsSelectedToUpdate } = this.props
    const groupedTickets = _.groupBy(ticketsSelectedToUpdate, ticket => ticket.region.id)
    const ticketsPerRegionInfo = _.map(Object.keys(groupedTickets), ticket => ({
      regionId: ticket,
      ticketsNumber: groupedTickets[ticket].length,
      tickets: groupedTickets[ticket],
      regionName: groupedTickets[ticket][0].region.name
    }))

    const regions = Object.keys(groupedTickets)

    if (regions.length > 1) {
      this.setState({ showAlertRegion: true })
      this.setState({ groupedTickets: ticketsPerRegionInfo })
      this.setState({
        errorTicketsRegion: `Tickets are from ${regions.length} different regions.
        You have to select only one region to update them. Which tickets do you want to update? `
      })
      const regionCheckBox = {}
      _.map(regions, (regionId) => { regionCheckBox[regionId] = false })
      this.setState({ selectedRegionToUpdate: regionCheckBox })
    } else {
      this.getCategoryServiceByRegion(_.head(regions))
      this.setState({ validTicketsToUpdate: ticketsSelectedToUpdate })
    }
  }

  getCategoryServiceByRegion = (currentRegion) => {
    this.resetToDefault()
    cloudhelpGet(`/api/regions/${currentRegion || 'global'}.json`)
      .then((response) => {
        const region = response.data
        const serviceCategoriesByRegion = _.map(filter(region.service_categories, { used_for_tickets: true }), serviceCategory => (
          {
            value: serviceCategory.id,
            label: serviceCategory.name,
            key: serviceCategory.id,
            subCategories: _(serviceCategory.sub_categories).map(subCategory => ({
              value: subCategory.id,
              label: subCategory.name,
              key: subCategory.id
            })).sortBy('label').value(),
            ticket_types: serviceCategory.ticket_types
          }
        ))
        
        const { ticketsSelectedToUpdate } = this.props
        const selectedTicketTypes = _.uniq(_.map(ticketsSelectedToUpdate, ticket => ticket.ticket_type))

        const filteredServiceCategoriesByTicketType = _.filter(serviceCategoriesByRegion, serviceCategory => (
          _.intersectionBy(selectedTicketTypes, serviceCategory.ticket_types.map(o => o.id)).length === selectedTicketTypes.length
        ))
        
        const unassignedServiceCategories = _.filter(serviceCategoriesByRegion, serviceCategory => (
          serviceCategory.ticket_types.length === 0
        ))

        this.setState({
          serviceCategories: _.sortBy([unassignedServiceCategories, filteredServiceCategoriesByTicketType].flat(), 'label'),
          regionStatuses: _.map(region.ticket_statuses,
            status => ({ value: status.id, label: status.name })),
          multipleTicketTypesSelected: selectedTicketTypes.length > 1
        })
      })
  }

  resetToDefault = () => {
    this.setState({
      serviceCategories: [],
      regionStatuses: []
    })
  }

  addEditedItem = (type) => {
    this.setState((prevState) => {
      const { fields } = prevState
      const { editedItems } = fields
      const newEditedItems = [...editedItems, { editableType: type }]
      const newFields = Object.assign({}, fields, { editedItems: newEditedItems })

      return { fields: newFields }
    })
  }

  attachHandlers = (editedItems) => {
    return (
      _.map(editedItems, (editedItem, index) => Object.assign({}, editedItem, {
        remove: () => this.removeEditedItem(index),
        updateOptionValue: (option, value) => this.updateOptionValue(index, option, value)
      }))
    )
  }

  updateOptionValue = (indexToUpdate, option, value) => {

    this.checkWhatisUpdated(indexToUpdate, value)
    this.setState((prevState) => {
      const { fields } = prevState
      const { editedItems } = fields
      let newFields
      if (option === 'firstValueId' && _.includes(optionsToUpdate, value)) {
        const newItem = Object.assign({}, { editableType: 'Attribute' })
        const newEditedItem = Object.assign({}, newItem, { [option]: value })
        const newEditedItems = Object.assign([...editedItems], { [indexToUpdate]: newEditedItem })
        newFields = Object.assign({}, fields, { editedItems: newEditedItems })
      } else {
        const editedItem = editedItems[indexToUpdate]
        const newEditedItem = Object.assign({}, editedItem, { [option]: value })
        const newEditedItems = Object.assign([...editedItems], { [indexToUpdate]: newEditedItem })
        newFields = Object.assign({}, fields, { editedItems: newEditedItems })
      }

      return { fields: newFields }
    })
  }

  checkWhatisUpdated = (indexToUpdate, value) => {
    const { onHoldStatusesId, resolvedStatusesId } = this.props
    const { fields } = this.state
    const { editedItems } = fields
    const editedItem = editedItems[indexToUpdate]

    if (editedItem.firstValueId === 'status' && (_.includes(onHoldStatusesId, value) || (_.includes(resolvedStatusesId, value)))) {
      this.setState({ showOnHoldOrResolved: true })
    }
  }

  checkWhatIsRemoved = (indexToRemove) => {
    const { onHoldStatusesId, resolvedStatusesId } = this.props
    const { fields } = this.state
    const { editedItems } = fields
    const removedItem = editedItems[indexToRemove]
    if (removedItem.firstValueId === 'client') {
      const currentRegion = this.getCurrentRegionFromSelectedCheckBox()
      this.setState({
        regionToUpdate: currentRegion,
        errorRegionClient: ''
      })
      this.getCategoryServiceByRegion(currentRegion)
    } else if (removedItem.firstValueId === 'status' && (_.includes(onHoldStatusesId, removedItem.statusId) || (_.includes(resolvedStatusesId, removedItem.statusId)))) {
      this.setState({ showOnHoldOrResolved: false })
    }
  }

  removeEditedItem = (indexToRemove) => {
    this.checkWhatIsRemoved(indexToRemove)

    this.setState((prevState) => {
      const { fields } = prevState
      const { editedItems } = fields
      const newEditedItems = _.filter(editedItems, (editedItem, index) => indexToRemove !== index)
      const newFields = Object.assign({}, { editedItems: newEditedItems })

      return { fields: newFields }
    })
  }

  getCurrentRegionFromSelectedCheckBox = () => {
    const { selectedRegionToUpdate } = this.state
    let currentRegion
    _.map(Object.keys(selectedRegionToUpdate), (key) => {
      if (selectedRegionToUpdate[key] === true) { currentRegion = key }
    })

    return currentRegion
  }

  checkIfQueueExists = () => {
    const { fields } = this.state
    const { editedItems } = fields

    let queueExists = false
    _.map(editedItems, (editedItem) => {
      if ((_.includes(editedItem, 'queue')) && !_.isNil(editedItem.queueId)) {
        queueExists = true
      }
    })

    return queueExists
  }

  checkIfQueueExistsInAssignee = () => {
    const { fields } = this.state
    const { editedItems } = fields

    let queueExists = false

    _.map(editedItems, (editedItem) => {
      if ((_.includes(editedItem, 'assignee')) && !_.isNil(editedItem.assigneeId) && !_.isNil(editedItem.queueId)) {
        queueExists = true
      }
    })

    return queueExists
  }

  isBlankValidation = (editedItem, attribute, humanName) => {
    if (_.isNil(editedItem[attribute])) {
      return { failed: true, message: `${humanName} cannot be blank.` }
    }
    return { failed: false }
  }

  isBlankValidationForOnHold = (editedItem, attribute, humanName) => {
    const { onHoldStatusesId } = this.props

    if (_.includes(onHoldStatusesId, editedItem.statusId)) {
      return this.isBlankValidation(editedItem, attribute, humanName)
    }
  }

  isBlankValidationForResolved = (editedItem, attribute, humanName) => {
    const { resolvedStatusesId } = this.props

    if (_.includes(resolvedStatusesId, editedItem.statusId)) {
      return this.isBlankValidation(editedItem, attribute, humanName)
    }
  }

  isDateInPastValidation = (editedItem, attribute, humanName) => {
    const { onHoldStatusesId } = this.props
    if (_.includes(onHoldStatusesId, editedItem.statusId)) {
      if (moment(editedItem[attribute]).isSameOrAfter(moment())) {
        return { failed: false }
      }
      return { failed: true, message: `${humanName} cannot be in the past.` }
    }
  }

  checkProprietyOfData = () => {
    const { fields } = this.state
    const { editedItems } = fields

    const fieldsToValidate = [
      {
        attributeName: 'clientId',
        type: 'string',
        humanName: 'Client',
        validations: [this.isBlankValidation],
        firstValueId: 'client'
      },
      {
        attributeName: 'clientContactId',
        type: 'string',
        humanName: 'Client contact',
        validations: [this.isBlankValidation],
        firstValueId: 'client'
      },
      {
        attributeName: 'categoryId',
        type: 'string',
        humanName: 'Category',
        validations: [this.isBlankValidation],
        firstValueId: 'category'
      },
      {
        attributeName: 'subCategoryId',
        type: 'string',
        humanName: 'Sub Category',
        validations: [this.isBlankValidation],
        firstValueId: 'category'
      },
      {
        attributeName: 'assigneeId',
        type: 'string',
        humanName: 'Assignee',
        validations: [this.isBlankValidation],
        firstValueId: 'assignee'
      },
      {
        attributeName: 'queueId',
        type: 'string',
        humanName: 'Queue',
        validations: this.checkIfQueueExists() ? [] : [this.isBlankValidation],
        firstValueId: 'assignee'
      },
      {
        attributeName: 'queueId',
        type: 'string',
        humanName: 'Queue',
        validations: this.checkIfQueueExistsInAssignee() ? [] : [ this.isBlankValidation],
        firstValueId: 'queue'
      },
      {
        attributeName: 'statusId',
        type: 'string',
        humanName: 'Status',
        validations: [this.isBlankValidation],
        firstValueId: 'status'
      },
      {
        attributeName: 'onHoldDate',
        type: 'date',
        validations: [this.isDateInPastValidation, this.isBlankValidationForOnHold],
        humanName: 'Re-open on',
        firstValueId: 'status'
      },
      {
        attributeName: 'onHoldDescritpion',
        type: 'string',
        validations: [this.isBlankValidationForOnHold],
        humanName: 'Description',
        firstValueId: 'status'
      },
      {
        attributeName: 'rootCause',
        type: 'string',
        validations: [this.isBlankValidationForResolved],
        humanName: 'Root cause',
        firstValueId: 'status'
      },
      {
        attributeName: 'preventAction',
        type: 'string',
        validations: [this.isBlankValidationForResolved],
        humanName: 'Preventive action',
        firstValueId: 'status'
      },
      {
        attributeName: 'correctiveAction',
        type: 'string',
        validations: [this.isBlankValidationForResolved],
        humanName: 'Corrective action',
        firstValueId: 'status'
      }
    ]

    const errors = []
    _.each(editedItems, (editedItem) => {
      _.each(fieldsToValidate, (field) => {
        if (editedItem.firstValueId === field.firstValueId) {
          const { validations } = field

          _.each(validations, (validationFunction) => {

            const validation = validationFunction(editedItem, field.attributeName, field.humanName)

            if (!_.isNil(validation) && validation.failed) { errors.push(validation.message) }
          })
        }
      })
    })

    this.setState({ fieldsErrors: errors })
    return _.isEmpty(errors)
  }
  submitForm = () => {
    const { bulkUpdatePath, onHoldStatusesId, resolvedStatusesId } = this.props
    const { fields, validTicketsToUpdate } = this.state
    const { editedItems } = fields

    if (this.checkProprietyOfData()) {
      // eslint-disable-next-line camelcase
      const ticket_ids = _.map(validTicketsToUpdate, ticket => ticket.ticketId)

      let inputData = {}
      _.forEach(editedItems, (editedItem) => {
        let itemAttributes = {}
        switch (editedItem.firstValueId) {
          case 'client':
            itemAttributes = {
              client_id: editedItem.clientId,
              client_contact_id: editedItem.clientContactId
            }
            break
          case 'category':
            itemAttributes = {
              service_category_id: editedItem.categoryId,
              sub_category_id: editedItem.subCategoryId
            }
            break
          case 'assignee':
            if (_.includes(Object.keys(inputData), 'queue_id')) {
              itemAttributes = {
                assignee_user_id: editedItem.assigneeId
              }
            } else {
              itemAttributes = {
                assignee_user_id: editedItem.assigneeId,
                queue_id: editedItem.queueId
              }
            }
            break
          case 'queue':
            if (!_.includes(Object.keys(inputData), 'queue_id')) {
              itemAttributes = {
                queue_id: editedItem.queueId
              }
            }
            break
          case 'status':
            if (_.includes(onHoldStatusesId, editedItem.statusId)) {
              itemAttributes = {
                status_id: editedItem.statusId,
                on_hold_at: moment(),
                reopen_on: editedItem.onHoldDate,
                on_hold_description: editedItem.onHoldDescritpion
              }
            } else if (_.includes(resolvedStatusesId, editedItem.statusId)) {
              itemAttributes = {
                status_id: editedItem.statusId,
                root_cause: editedItem.rootCause,
                preventive_action: editedItem.preventAction,
                corrective_action: editedItem.correctiveAction
              }
            } else {
              itemAttributes = {
                status_id: editedItem.statusId
              }
            }
            break
          case 'ticket_type':
            itemAttributes = { ticket_type_id: editedItem.ticketType }
            break
          case 'priority':
            itemAttributes = { priority_id: editedItem.priority }
            break
          default:
            break
        }
        inputData = Object.assign({}, inputData, itemAttributes)
      })

      const body = { tickets: { ticket_ids, inputData } }

      cloudhelpPatch(bulkUpdatePath, body)
        .then((response) => {
          const { data } = response

          this.setState({
            alert: {
              showAlert: true,
              alertType: data.error ? 'error' : 'success',
              alertText: data.error ? data.error : data.success
            }
          })

          if (!data.error) {
            window.location.href = response.data.redirect_url
          }
        })
    }
  }

  chekcSubmitButton = (selectedOptions) => {
    const { errorTicketsRegion, selectedRegionToUpdate } = this.state

    return ((!_.isEmpty(errorTicketsRegion) &&
    (_.filter(Object.values(selectedRegionToUpdate), el => el === true).length !== 1)) ||
      (selectedOptions.length === 1 && selectedOptions[0] === undefined))
  }

  addToUpdateTicketsFromExactRegion = (value, regionId) => {
    const { selectedRegionToUpdate } = this.state

    _.map(Object.keys(selectedRegionToUpdate), (region) => {
      if (region === regionId) { selectedRegionToUpdate[region] = value }
    })
    this.setState({ selectedRegionToUpdate })

    this.checkIfCurrentRegionCanBeFetched()
  }

  checkIfCurrentRegionCanBeFetched = () => {
    const { selectedRegionToUpdate, groupedTickets } = this.state

    if (_.filter(Object.values(selectedRegionToUpdate), el => el === true).length === 1) {
      let currentRegion
      _.map(Object.keys(selectedRegionToUpdate), (key) => {
        if (selectedRegionToUpdate[key] === true) { currentRegion = key }
      })
      let ticketsForUpdateFromRegion = []
      _.map(groupedTickets, (group) => {
        if (group.regionId === currentRegion) { ticketsForUpdateFromRegion = group.tickets }
      })
      this.setState({ regionToUpdate: currentRegion })
      this.setState({ validTicketsToUpdate: ticketsForUpdateFromRegion })

      this.getCategoryServiceByRegion(currentRegion)
    }
  }

  setRegionToUpdate = (region) => {
    this.setState({ regionToUpdate: region })
  }

  setErrorRegionClient = (error) => {
    this.setState({ errorRegionClient: error })
  }

  render () {
    const {
      attachHandlers,
      addEditedItem,
      setRegionToUpdate,
      getCategoryServiceByRegion,
      setErrorRegionClient
    } = this

    const {
      clients,
      onHoldStatusesId,
      resolvedStatusesId,
      assigneesQueues,
      removeModal,
      queuesAssignees,
      queues,
      priorities,
      ticketTypes
    } = this.props

    const {
      fields,
      serviceCategories,
      regionStatuses,
      showAlertRegion,
      errorTicketsRegion,
      errorRegionClient,
      groupedTickets,
      selectedRegionToUpdate,
      regionToUpdate,
      fieldsErrors,
      showOnHoldOrResolved,
      alert: {
        showAlert,
        alertType,
        alertText
      },
      multipleTicketTypesSelected
    } = this.state

    const { editedItems } = fields

    const options = {
      attribute: {
        category: serviceCategories,
        status: regionStatuses,
        assignee: assigneesQueues,
        queue: _.map(queues, queue => ({
          label: queue.name,
          value: queue.id
        })),
        client: _.map(clients, option => ({
          label: option.short_name,
          value: option.id,
          region: option.region_id
        })),
        ticket_type: [],
        priority: []
      }
    }

    const editedItemsWithHandlers = attachHandlers(editedItems)
    let optionsIds = []

    return (
      <div>
        { showAlert && (
          <Alert type={alertType} title={alertText} />
        )}

        {showAlertRegion && (
          <Alert alertType="error" title={errorTicketsRegion}>
            <Row classExtra="flex--centered">
              {_.map(groupedTickets, ticket => (
                <FormInputCheckbox
                  inline
                  id={ticket.regionId}
                  value={selectedRegionToUpdate[ticket.regionId]}
                  onValue={(value) => { this.addToUpdateTicketsFromExactRegion(value, ticket.regionId) }}
                >
                  {`${ticket.ticketsNumber} from ${ticket.regionName}`}
                </FormInputCheckbox>
              ))}
            </Row>
          </Alert>
        )}

        {!_.isEmpty(errorRegionClient) && (
          <Alert type="error" title={errorRegionClient} />
        )}

        {multipleTicketTypesSelected && (
          <Alert type="warning" title="Multiple ticket types selected">
            <br />
            Some categories will not be available
          </Alert>
        )}

        {!_.isEmpty(fieldsErrors) && (
          <Alert alertType="error">
            {fieldsErrors}
          </Alert>
        )}

        {_.map(types, (type) => {
          const typeEditedItems = _.filter(
            editedItemsWithHandlers, { editableType: type.editableType }
          )

          optionsIds = _.map(typeEditedItems, editedItem => editedItem.firstValueId)

          const typeOptions = _.map(Object.keys(options[type.keySelector]), key => ({
            label: `${(key.charAt(0).toUpperCase() + key.slice(1)).replace('_', ' ')}`,
            value: key,
            disabled: _.includes(optionsIds, key)
          }))

          return (
            <AssociatedItemsSelectors
              editedItems={typeEditedItems}
              options={typeOptions}
              addEditedItem={() => { addEditedItem(type.editableType) }}
              type={type.editableType}
              optionValues={options[type.keySelector]}
              onHoldValues={onHoldStatusesId}
              resolvedStatusesId={resolvedStatusesId}
              queuesAssignees={queuesAssignees}
              selectedOptions={optionsIds}
              setRegionToUpdate={setRegionToUpdate}
              getCategoryServiceByRegion={getCategoryServiceByRegion}
              setErrorRegionClient={setErrorRegionClient}
              regionToUpdate={regionToUpdate}
              showOnHoldOrResolved={showOnHoldOrResolved}
              priorities={priorities}
              ticketTypes={ticketTypes}
            />
          )
        })}

        <Row>
          <Col>
            <ButtonContainer center spaced>
              <Button onClick={() => { removeModal() }}>
                Cancel
              </Button>
              <Button onClick={() => { this.submitForm() }} disabled={this.chekcSubmitButton(optionsIds)}>
                Save
              </Button>
            </ButtonContainer>
          </Col>
        </Row>
      </div>
    )
  }
}

export default BulkUpdateForm
